import { useCallback } from "react";
import { useWorkflowLock } from "../api/WorkflowApi";

export type ReportOriginType =
  | "in_process"
  | "direct"
  | "task_assignment"
  | "360_workbench"
  | "360_claim"
  | "none";

export function useLockModal() {
  const {
    data,
    isLoading: isLoadingWorkflowLock,
    mutateAsync: lockWorkflow,
    error: errorWorkflowLock,
    reset: resetWorkflowLock,
  } = useWorkflowLock();

  const lock = useCallback(
    async (workflowRunUUID: string, origin?: ReportOriginType) => {
      await lockWorkflow({ workflowRunUUID, origin });
    },
    [lockWorkflow]
  );

  return {
    lockedWorkflowRun: data,
    isLoadingWorkflowLock,
    errorWorkflowLock,
    lock,
    resetWorkflowLock,
  };
}

export const REPORT_ORIGIN_KEY = "reportOrigin";

export function useReportOriginManager() {
  const setOrigin = useCallback((origin: ReportOriginType) => {
    localStorage.setItem(REPORT_ORIGIN_KEY, origin);
  }, []);

  // Get the origin from local storage and clear it after reading
  const getOrigin = useCallback(() => {
    const currentOrigin = localStorage.getItem(REPORT_ORIGIN_KEY) ?? "none";
    setOrigin("none");
    return currentOrigin as ReportOriginType;
  }, [setOrigin]);

  return {
    setOrigin,
    getOrigin,
  };
}
